// Single source of truth for document entity_type classification (label, color, icon).
// Replaces the 3 previously-duplicated, inconsistently-incomplete lists that lived in:
//   - DocumentCenter.jsx  (ENTITY_CONFIG)
//   - DocumentPanel.jsx   (typeLabel)
//   - DocumentGovernance.jsx (TYPE_CONFIG)
//
// Covers the actual entity_type values written into the `documents` table across the app
// (confirmed via Stage 0.5 audit — grep of every <DocButton entityType="..."> call site).
//
// If a new entity_type value is introduced anywhere in the app, add it here FIRST —
// every screen that displays a document type name/color/icon should read from this file.

export const DOCUMENT_TYPES = {
  purchase_order: {
    label: 'Purchase Orders',
    color: '#2563EB',
    bg: 'rgba(37,99,235,.08)',
    icon: '📋',
  },
  subcontract: {
    label: 'Subcontracts',
    color: '#D97706',
    bg: 'rgba(217,119,6,.08)',
    icon: '📝',
  },
  equipment_contract: {
    label: 'Equipment Contracts',
    color: '#B45309',
    bg: 'rgba(180,83,9,.08)',
    icon: '🚜',
  },
  ipc: {
    label: 'IPC Certificates',
    color: '#7C3AED',
    bg: 'rgba(124,58,237,.08)',
    icon: '🏗',
  },
  equipment_ipc: {
    label: 'Equipment IPC',
    color: '#6D28D9',
    bg: 'rgba(109,40,217,.08)',
    icon: '🏗',
  },
  finance: {
    label: 'Finance',
    color: '#059669',
    bg: 'rgba(5,150,105,.08)',
    icon: '💰',
  },
}

// Fallback for any entity_type value not (yet) registered above.
// Screens should use this instead of silently mislabeling as a wrong known type.
export const UNKNOWN_DOCUMENT_TYPE = {
  label: 'Other',
  color: '#6B7280',
  bg: 'rgba(107,114,128,.08)',
  icon: '📎',
}

// Convenience getter — always returns a valid config object, never undefined.
export function getDocumentTypeConfig(entityType) {
  return DOCUMENT_TYPES[entityType] || UNKNOWN_DOCUMENT_TYPE
}
